module.exports = __webpack_public_path__ + "5c9c62d9385ea4d031fb994738bc065c.woff";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/LiveChat.woff
// module id = 335
// module chunks = 0